import { BookOpen } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "accounting",
  icon: BookOpen,
  tabs: [
    { to: "/accounting/journal", label: "nav.journal", perm: ["accounting.entry.read"] },
    { to: "/accounting/accounts", label: "nav.chart", perm: ["accounting.account.read"] },
    { to: "/accounting/periodic", label: "nav.periodic", perm: ["accounting.entry.read"] },
    { to: "/accounting/bank", label: "nav.bank", perm: ["accounting.bank.manage"] },
    { to: "/accounting/assets", label: "nav.assets", perm: ["accounting.asset.read"] },
    { to: "/accounting/budgets", label: "nav.budgets", perm: ["accounting.budget.read"] },
    { to: "/accounting/reports", label: "nav.finStatements", perm: ["accounting.report.read"] },
  ],
  create: [{ label: "create.entry", to: "/accounting/journal?new=1", perm: "accounting.entry.create" }],
  settings: { to: "/settings/accounting", perm: ["accounting.settings.manage", "accounting.period.manage"] },

};
